import { http } from '@shared/api';
import type { UUID } from '@shared/api';

export type MediaScope =
  | 'PROFILE_LOGO'
  | 'PRODUCT_VIDEO'
  | 'PRODUCT_PHOTO'
  | 'CERTIFICATE'
  | 'ECO_CERTIFICATE'
  | 'BUY_REQUEST_ATTACHMENT';

interface UploadTicket {
  mediaId: UUID;
  uploadUrl: string;
  method: 'PUT' | 'POST';
}

export const mediaApi = {
  requestUpload: (scope: MediaScope, contentType: string, sizeBytes: number) =>
    http.post('media/uploads', { json: { scope, contentType, sizeBytes } }).json<UploadTicket>(),

  confirmUpload: (mediaId: UUID) =>
    http.post(`media/uploads/${mediaId}/confirm`).json<void>(),

  /**
   * Full three-step upload flow: ticket → PUT to storage → confirm.
   * Returns the mediaId to persist in the domain object.
   */
  uploadFile: async (scope: MediaScope, file: File): Promise<UUID> => {
    const ticket = await mediaApi.requestUpload(scope, file.type, file.size);
    const res = await fetch(ticket.uploadUrl, {
      method: ticket.method,
      headers: { 'Content-Type': file.type },
      body: file,
    });
    if (!res.ok) throw new Error(`Upload failed: ${res.status} ${res.statusText}`);
    await mediaApi.confirmUpload(ticket.mediaId);
    return ticket.mediaId;
  },
};
